import { OrganisationResponseV1 } from "@ucchub/ui/src/apiTypes/organisation";
import environment from "environment";
import { BaseService } from "@services/BaseService";
import {
  CustomerDetails,
  CustomerProduct,
} from "@components/customer/Customer.types";
import { useState } from "react";
import { t } from "i18next";
import { unescapeObjectValues } from "@ucchub/ui";

const KEYS_TO_BE_UNESCAPED: (keyof CustomerDetails)[] = [
  "addressLine1",
  "addressLine2",
  "area",
  "city",
  "contactEmail",
  "contactFirstName",
  "contactLastName",
  "country",
  "name",
  "postcode",
  "pid",
];

const useCustomerDetails = () => {
  const [customerDetails, setCustomerDetails] = useState<CustomerDetails>();
  const [customerProducts, setCustomerProducts] = useState<CustomerProduct[]>();

  const [error, setError] = useState<string>();
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);

  const fetchCustomerDetails = (orgId: string) => {
    setIsCustomerLoading(true);
    setError("");
    const apiUrl = environment.api.customer + `/${orgId}`;

    BaseService.get<OrganisationResponseV1>(apiUrl)
      .then(({ data }) => {
        const { products, ...newCustomerDetails } = data;
        setCustomerDetails(
          unescapeObjectValues(newCustomerDetails, KEYS_TO_BE_UNESCAPED)
        );
        setCustomerProducts(products);
      })
      .catch(() => {
        setError(t("core:customers:fetch_failure") || undefined);
      })
      .finally(() => {
        setIsCustomerLoading(false);
      });
  };

  return {
    customerDetails,
    error,
    customerProducts,
    isCustomerLoading,
    fetchCustomerDetails,
  };
};

export default useCustomerDetails;
